import React from 'react';
import ReactDOM from 'react-dom';
import { AnalyticsProvider } from '@medely/ui-kit/web';
import App from './App';
import config from './config';
import * as serviceWorker from './serviceWorker';

window.alert = () => {
  console.log('alert blocked');
};

document.addEventListener(
  'wheel',
  function disableScrollInNumberInputs() {
    if (
      document.activeElement?.nodeName === 'INPUT' &&
      document.activeElement?.getAttribute('type') === 'number'
    ) {
      const activeElement = document.activeElement as any;
      activeElement.blur();
    }
  },
  { passive: false },
);

ReactDOM.render(
  <AnalyticsProvider
    writeKey={config.segmentWriteKey}
    sessionCreatePayload={{
      context: 'Admin Session',
      action: 'Started',
      session_access_type: 'web',
    }}
  >
    <App />
  </AnalyticsProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
